import { BloodTypesEnum } from "../../Types/Enums/BloodTypesEnum";

export const BLOOD_TYPES = [
  { id: BloodTypesEnum.OP, labels: { 0: "O+", 1: "O+" } },
  { id: BloodTypesEnum.ON, labels: { 0: "O-", 1: "O-" } },
  { id: BloodTypesEnum.AP, labels: { 0: "A+", 1: "A+" } },
  { id: BloodTypesEnum.AN, labels: { 0: "A-", 1: "A-" } },
  { id: BloodTypesEnum.BP, labels: { 0: "B+", 1: "B+" } },
  { id: BloodTypesEnum.BN, labels: { 0: "B-", 1: "B-" } },
  { id: BloodTypesEnum.ABP, labels: { 0: "AB+", 1: "AB+" } },
  { id: BloodTypesEnum.ABN, labels: { 0: "AB-", 1: "AB-" } }
];